import { ScopeName } from './Scope';

const TranslationParticipantPage = {
  [`${ScopeName}.title`]: 'Página do usuário',
  [`${ScopeName}.content`]: 'Página do usuário',
};

export default TranslationParticipantPage;
